import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Button } from '../../elements';
import { T } from '../../helpers/i18n';
import { isInRange } from './Utils';
import moment from 'moment';
export var ModalDisableHours = function (props) {
    var daySelected = props.daySelected, horasIda = props.horasIda, tramoHora = props.tramoHora, showModal = props.showModal, externalCloseBtn = props.externalCloseBtn, rangeFrom = props.rangeFrom, rangeTo = props.rangeTo, title = props.title, onToggle = props.onToggle, onHourClick = props.onHourClick, onOKClick = props.onOKClick, onOKRangeClick = props.onOKRangeClick, handleCancelClick = props.handleCancelClick, enableAll = props.enableAll, disableAll = props.disableAll, onRangeTo = props.onRangeTo, onRangeFrom = props.onRangeFrom, onClearRange = props.onClearRange, onClickBar = props.onClickBar;
    var inRange = daySelected && isInRange(rangeFrom, rangeTo, new Date(daySelected.year, daySelected.month, daySelected.day, 0, 0, 0, 0));
    if (!daySelected)
        return null;
    var _daySelected = new Date(daySelected.year, daySelected.month, daySelected.day, 0, 0, 0, 0);
    var strDate = moment(_daySelected).format('DD/MM/YYYY');
    if (rangeFrom && rangeTo) {
        var from = new Date(rangeFrom.year, rangeFrom.month, rangeFrom.day);
        var to = new Date(rangeTo.year, rangeTo.month, rangeTo.day);
        strDate = "".concat(moment(from).format('DD/MM/YYYY'), " - ").concat(moment(to).format('DD/MM/YYYY'));
    }
    return (React.createElement(Modal, { centered: true, fade: true, 
        /*isOpen={!!daySelected}*/
        isOpen: showModal, toggle: onToggle, external: externalCloseBtn },
        React.createElement(ModalHeader, { toggle: onToggle },
            React.createElement("span", null,
                " ",
                title,
                " "),
            React.createElement("span", null,
                " ",
                React.createElement("div", null, strDate),
                " ")),
        React.createElement(ModalBody, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                } },
                !tramoHora && daySelected.hours && React.createElement("div", null,
                    React.createElement(Button, { onClick: enableAll }, T('enable'))),
                !tramoHora && !daySelected.hours && React.createElement("div", null,
                    React.createElement(Button, { onClick: disableAll }, T('disable'))),
                tramoHora && daySelected.hours.length === horasIda.length && React.createElement("div", null,
                    React.createElement(Button, { onClick: enableAll }, T('enableAll'))),
                tramoHora && daySelected.hours.length === 0 && React.createElement("div", null,
                    React.createElement(Button, { onClick: disableAll }, T('disableAll'))),
                !rangeFrom && React.createElement("div", null,
                    React.createElement(Button, { onClick: function () {
                            if (onRangeFrom) {
                                onRangeFrom(daySelected);
                            }
                        } }, T('fromRange'))),
                rangeFrom && !rangeTo && React.createElement("div", null,
                    React.createElement(Button, { onClick: function () {
                            if (onRangeTo) {
                                onRangeTo(daySelected);
                            }
                        } }, T('toRange'))),
                rangeFrom && rangeTo && React.createElement("div", null,
                    React.createElement(Button, { onClick: function () {
                            if (onClearRange) {
                                onClearRange();
                            }
                        } }, T('clearRange')))),
            React.createElement("div", null,
                !tramoHora && React.createElement("div", { onClick: onClickBar, style: {
                        backgroundColor: (daySelected === null || daySelected === void 0 ? void 0 : daySelected.hours) ? 'red' : 'green',
                        height: '50px',
                    } }),
                tramoHora && horasIda.map(function (horaIda) {
                    return (React.createElement("div", { key: horaIda.id, style: {
                            backgroundColor: daySelected && daySelected.hours ?
                                daySelected.hours.findIndex(function (value) { return value.hours === horaIda.hours && value.minutes === horaIda.minutes; }) !== -1 ? 'red' : 'green' : 'green',
                            color: 'white',
                            margin: '1px'
                        }, onClick: function () { return onHourClick(daySelected, horaIda); } }, "".concat(horaIda.hours > 9 ? horaIda.hours : '0' + horaIda.hours, ":").concat(horaIda.minutes > 9 ? horaIda.minutes : '0' + horaIda.minutes)));
                }),
                React.createElement("hr", null),
                React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                    daySelected && !inRange && React.createElement(Button, { onClick: onOKClick }, T('ok')),
                    daySelected && inRange && React.createElement(Button, { onClick: onOKRangeClick }, T('okRange')),
                    React.createElement(Button, { onClick: handleCancelClick }, T('cancel')))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarAvailable/ModalDisableHours.tsx
// module id = 1266
// module chunks = 0